import { z } from 'zod';
import axiosInstance from '@/lib/axiosInstance';
import { Classroom } from '@/model/Classroom.model';
import { ClassroomAccessRole } from '@/model/common/access-common/ClassroomAccessRole.enum';
import { School } from '@/model/School/School.model';
import { User } from '@/model/User.model';

export enum ResourceType {
  Classroom = 'classrooms',
  School = 'schools',
}
export interface AddOrRemoveClassroomUserDto {
  userId: string;
  classroomId: string;
  role: ClassroomAccessRole; // add `UserRole` is a hack because the underlying values are the same
}

export const addUserToClassroom = async (dto: AddOrRemoveClassroomUserDto): Promise<void> => {
  return await axiosInstance.post(`/user-resource-access/classroom`, {
    classroomId: dto.classroomId,
    userId: dto.userId,
    role: dto.role,
  });
};

export const addUsersToClassrooms = async (dtos: AddOrRemoveClassroomUserDto[]): Promise<void> => {
  return await axiosInstance.post(`/user-resource-access/classrooms`, dtos);
};

export const removeUserFromClassroom = async (dto: AddOrRemoveClassroomUserDto): Promise<void> => {
  const { userId, classroomId } = dto;
  return await axiosInstance.delete(`/user-resource-access/classrooms/${classroomId}/users/${userId}`, {
    params: {
      role: dto.role,
    },
  });
};

export const getCurrentUserAccessibleClassrooms = async () => {
  const { data } = await axiosInstance.get('/user-resource-access/users/me/classrooms');
  return Classroom.fromJsonArray(data);
};

export const getUserAccessibleClassrooms = async (userId: string) => {
  const { data } = await axiosInstance.get(`/user-resource-access/users/${userId}/classrooms`);
  return Classroom.fromJsonArray(data);
};

export const getCurrentUserAccessibleSchools = async () => {
  const { data } = await axiosInstance.get('/user-resource-access/users/me/schools');
  return School.fromJsonArray(data);
};

export const getCurrentUserAccessibleUsers = async () => {
  const { data } = await axiosInstance.get('/user-resource-access/users/me/users');
  return User.fromJsonArray(data);
};

export interface GetUserWebappRoutesAccessParams {
  classroomId?: string;
  lessonInstanceId?: string;
  activityInstanceId?: string;
}
export const getUserWebappRoutesAccess = async (params: GetUserWebappRoutesAccessParams) => {
  const { data } = await axiosInstance.get<unknown>('/user-resource-access/users/me/webapp-routes-access', {
    params: params,
  });

  return z.object({ hasAccess: z.boolean() }).parse(data);
};
